import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIconBlue from "../img/svg/close_blue_new_design.svg";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function LocationPopup({ isOpen, setIsOpen, headerTextTop, headerTextBottom, bodyText }) {
  const { t } = useTranslation();
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{ p: 0 }}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <Box>
        <Box>
          <DialogTitle
            sx={{
              m: 0,
              p: 2,
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              gap: "5px",
              textAlign: "center",
            }}
            id="customized-dialog-title"
          >
            <img src={CloseIconBlue} alt={t("CLOSE")} onClick={() => handleClose()} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <Typography
                gutterBottom
                className="open-sans-hebrew"
                sx={{
                  fontFamily: `var(--font-family) !important`,
                  fontSize: "24px",
                  m: 0,
                  color: "var(--red-text-color)",
                  textAlign: "center",
                  lineHeight: "28px",
                  fontWeight: 700,
                }}
              >
                {headerTextTop}
              </Typography>
              <Typography
                gutterBottom
                className="open-sans-hebrew"
                sx={{
                  fontFamily: `var(--font-family) !important`,
                  fontSize: "24px",
                  m: 0,
                  lineHeight: "28px",
                  color: "var(--red-text-color)",
                  textAlign: "center",
                  fontWeight: 700,
                }}
              >
                {headerTextBottom}
              </Typography>
            </Box>
          </DialogTitle>
        </Box>
        <DialogContent
          sx={{
            direction: "rtl",
            display: "flex",
            flexDirection: "column",
            gap: "40px",
          }}
        >
          <Typography
            gutterBottom
            sx={{
              lineHeight: "24px",
              fontSize: "16px",
              m: 0,
              fontFamily: `var(--font-family) !important`,
              textAlign: "right",
              maxWidth: "230px",
              mb: "53px",
            }}
          >
            {bodyText}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 0, m: "0px" }}>
          <Button
            variant="contained"
            className="phone-dialog-btn phone-dialog-darkblue-btn w-100-percents"
            onClick={() => handleClose()}
            sx={{
              height: "58px",
              fontFamily: `var(--font-family) !important`,
            }}
          >
            {t("CLOSE_PAY")}
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
}
